/*
 * External service integrations migrated from Symmetry_20250529published.
 * Microsoft Clarity project: r0rop5u9op
 * Paidy Promotional Messaging widget loader.
 */
(function () {
  'use strict';

  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  var clarityScript = document.createElement('script');
  clarityScript.async = true;
  clarityScript.src = 'https://www.clarity.ms/tag/r0rop5u9op';
  var firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(clarityScript, firstScript);

  var paidyScript = document.createElement('script');
  paidyScript.src = 'https://cdn.paidy.com/promotional-messaging/general/paidy-upsell-widget.js';
  paidyScript.defer = true;
  document.head.appendChild(paidyScript);
})();
